import { render } from "./MyVacation.vue?vue&type=template&id=53d67e95"
import script from "./MyVacation.vue?vue&type=script&lang=js"
export * from "./MyVacation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__